import { TRACKING_CURRENCY } from '../../const';
import { getCartItemsTracking } from '../../helpers';
import type { RootState } from 'core/store';

export const cartPaymentOption = (prevState: RootState) => {
  const { checkout, cart } = prevState;
  const paymentOptionName = checkout.paymentOption?.name ?? '';
  const paymentType = checkout.paymentOption?.paymentPlanType;

  const paymentTypeName =
    checkout.paymentMethods.data[paymentType as keyof typeof checkout.paymentMethods.data]?.name ??
    '';
  return {
    event: 'add_payment_info',
    ecommerce: {
      currency: TRACKING_CURRENCY,
      value: cart.data?.totalNum,
      payment_type: paymentTypeName || paymentOptionName,
      coupon: cart.data?.coupon?.description || '',
      items: getCartItemsTracking(prevState),
    },
  };
};
